import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, red, unityRed } from '../colors';
import { GetThemeOptions } from '../../theme';

export const errorColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityRed[600],
          highContrast: unityRed[700],
          lowContrast: unityRed[100],
        }
      : {
          main: unityRed[500],
          highContrast: unityRed[100],
          lowContrast: unityRed[800],
        };
  }

  return mode === 'light'
    ? {
        main: red[600],
        highContrast: red[700],
        lowContrast: red[100],
      }
    : {
        main: red[500],
        highContrast: red[100],
        lowContrast: red[800],
      };
};
